import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Icon,
  Switch,
  IconButton,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  CardHeader,
  CardMedia,
} from "@material-ui/core";
import avatar from "assets/img/faces/dummyProfile.png";
import CardBody from "components/Card/CardBody.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CreateIcon from "@material-ui/icons/Create";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";
import axios from "axios";

import { USERS, ROLES } from "../../configs/urls";
import { ROLES as USER_ROLES, STATUS_TYPES } from "../../configs/constant";
import { getApi, deleteApi, putApi } from "../../services/api";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import FaceIcon from "@material-ui/icons/Face";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import GetAppIcon from "@material-ui/icons/GetApp";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Toaster from "../../components/Toaster";
import TimelineIcon from "@material-ui/icons/Timeline";
import { IMAGE_BASE_URL } from "../../configs/constant";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  addUserButton: {
    height: "56px !important",
    margin: "0 0 0 -18px",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  appBar: {
    position: "relative",
  },
  modalTitle: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  mediaCard: {
    marginTop: 30,
  },
  media: {
    height: 0,
    paddingTop: "75%", // 16:9
  },
  formControl: {
    marginRight: 10,
  },
  profile: {
    height: 130,
    width: 130,
  },
}));

export default function Users() {
  const classes = useStyles();
  const [users, setUsersList] = useState([]);
  const [userLocation, setUserLocation] = useState(
    "This feature is coming soon."
  );
  const [roles, setRolesList] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedRole, setSelectedRole] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState(STATUS_TYPES[0].id);
  const [params, setParams] = useState({
    page: 0,
    size: 10,
    role: "all",
    active: 1,
  });
  const [totalUsersCount, setTotalUsersCount] = useState(0);
  const [isRequesting, setIsRequestig] = useState(false);
  const [popupOpen, setPopupOpen] = React.useState(false);
  const [locationPopupOpen, setLocationPopupOpen] = useState(false);

  useEffect(() => {
    getAllData();

    return function () {
      /**
       * Add cleanup code here
       */
      setIsRequestig(false);
    };
  }, []); //eslint-disable-line

  useEffect(() => {
    fetchUsers();

    return function () {
      /**
       * Add cleanup code here
       */
      setIsRequestig(false);
    };
  }, [params]); //eslint-disable-line

  const getAllData = () => {
    setIsRequestig(true);

    const users = getApi(USERS, params);
    const roles = getApi(ROLES);
    axios
      .all([users, roles])
      .then((res) => {
        if (res[0] && res[0]?.data) {
          setTotalUsersCount(res[0].meta.total);
          setUsersList(res[0].data);
        }

        if (res[1] && res[1]?.data) {
          res[1].data.unshift({
            id: "all",
            slug: "all",
            name: "All",
          });
          setRolesList(res[1].data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const fetchUsers = () => {
    if (params.role == "all") {
      delete params.role;
    }
    getApi(USERS, params).then(
      (res) => {
        const data = res.data || [];
        setTotalUsersCount(res.meta.total);
        const newUserList = [...users, ...data];
        setUsersList(newUserList);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const deleteUser = (id, idx) => {
    setIsRequestig(true);
    deleteApi(USERS + "/" + id)
      .then(
        (res) => {
          let list = users;
          list.splice(idx, 1);
          setUsersList(list);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const handleStatusChange = (user, idx) => {
    setIsRequestig(true);
    const params = {
      id: user.id,
      active: user.active == 1 ? 0 : 1,
    };
    putApi(USERS, params)
      .then(
        () => {
          let list = [...users];
          list[idx].active = params.active;
          setUsersList(list);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const handleRoleChange = (event) => {
    const value = event.target.value;
    setUsersList([]);
    setSelectedRole(value);
    setParams({ ...params, page: 0, role: value });
  };

  const handleActiveChange = (event) => {
    const value = event.target.value;
    setUsersList([]);
    setSelectedStatus(value);
    setParams({ ...params, page: 0, active: value });
  };

  const loadMoreUsers = () => {
    setParams({ ...params, page: (params.page += 1) });
  };

  const openUserDetailsInModal = (user) => {
    setSelectedUser(user);
    setPopupOpen(true);
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
  };

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const openLocationDialog = () => (
    <Dialog
      open={locationPopupOpen}
      onClose={() => setLocationPopupOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"User's last tracked location tracked"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {userLocation || "N/A"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setLocationPopupOpen(false)}
          color="primary"
          autoFocus
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  const openUserLocation = (user) => {
    const { device } = user;

    if (device.length <= 0) {
      Toaster.showError("No location found");
      return;
    }
    const location = device[0];

    const latlng = {
      lat: parseFloat(location.latitude),
      lng: parseFloat(location.longitude),
    };

    if (!window.google) {
      alert("Please make sure your internet is working");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          setUserLocation(results[0].formatted_address);
          setLocationPopupOpen(true);
        } else {
          window.alert("No results/valid location found");
        }
      }
    });
  };

  const [showDemo1, setShowDemo1] = useState(false);
  const [showDemo2, setShowDemo2] = useState(false);

  const handleClickdemo1 = () => {
    setShowDemo1(!showDemo1);
    if (showDemo2 === true) {
      setShowDemo2(false);
    }
  };
  const handleClickdemo2 = () => {
    setShowDemo2(!showDemo2);
    if (showDemo1 == true) {
      setShowDemo1(false);
    }
  };

  const renderDialog = () =>
    popupOpen && (
      <Dialog
        fullScreen
        open={popupOpen}
        onClose={handlePopupClose}
        // TransitionComponent={Transition}
        // style={{ overflow: "scroll" }}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handlePopupClose}
              aria-label="close"
            >
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h6" className={classes.modalTitle}>
              User Details
            </Typography>
            <Button autoFocus color="inherit" onClick={handlePopupClose}>
              Close
            </Button>
          </Toolbar>
        </AppBar>
        <GridContainer style={{ paddingLeft: 20, paddingRight: 20 }}>
          <GridItem
            xs={12}
            sm={12}
            md={4}
            style={{ marginLeft: "auto", marginRight: "auto" }}
          >
            <Card
              profile
              style={{
                paddingTop: 100,
                textAlign: "center",
              }}
            >
              <CardAvatar profile className={classes.profile}>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <img
                    src={
                      selectedUser.profile_pic2
                        ? `${IMAGE_BASE_URL}${selectedUser.profile_pic}`
                        : avatar
                    }
                    alt="..."
                  />
                </a>
              </CardAvatar>
              <CardBody profile>
                <List className={classes.root}>
                  <ListItem className={classes.listItem}>
                    {/* <ListItemAvatar>
                      <Avatar>
                        <FaceIcon />
                      </Avatar>
                    </ListItemAvatar> */}
                    <ListItemText secondary={selectedUser.name} />
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    {/* <ListItemAvatar>
                      <Avatar>
                        <MailOutlineIcon />
                      </Avatar>
                    </ListItemAvatar> */}
                    <ListItemText
                      secondary={
                        selectedUser.email === null || undefined || "NULL"
                          ? ""
                          : selectedUser.email
                      }
                    />
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    {/* <ListItemAvatar>
                      <Avatar>
                        <PhoneAndroidIcon />
                      </Avatar>
                    </ListItemAvatar> */}
                    <ListItemText
                      secondary={selectedUser.mobile_no || "Not Available"}
                    />
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    {/* <ListItemAvatar>
                      <Avatar>
                        <AssignmentIndIcon />
                      </Avatar>
                    </ListItemAvatar> */}
                    <ListItemText secondary={selectedUser.role.name} />
                  </ListItem>
                  <ListItem className={classes.listItem}>
                    {/* <ListItemAvatar>
                      <Avatar>
                        <AssignmentIndIcon />
                      </Avatar>
                    </ListItemAvatar> */}
                    <ListItemText>
                      {" "}
                      <div>
                        <Button
                          style={{
                            background: "#d3d3d3",
                            color: "black",
                            width: "100%",
                          }}
                          onClick={() => handleClickdemo1()}
                        >
                          {" "}
                          Demo 1
                        </Button>{" "}
                      </div>
                      <div style={{ marginTop: "20px" }}>
                        <Button
                          style={{
                            background: "#d3d3d3",
                            color: "black",
                            width: "100%",
                          }}
                          onClick={() => handleClickdemo2()}
                        >
                          {" "}
                          Demo 2
                        </Button>{" "}
                      </div>
                    </ListItemText>
                  </ListItem>
                </List>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={4}
            style={{ marginLeft: "auto", marginRight: "auto" }}
          >
            <Card
              className={classes.mediaCard}
              style={showDemo1 ? { display: "block" } : { display: "none" }}
            >
              <CardHeader
                avatar={
                  <Avatar aria-label="recipe" className={classes.avatar}>
                    D1
                  </Avatar>
                }
                title={
                  selectedUser.doc1_type ? selectedUser.doc1_type : "Document 1"
                }
                action={
                  <a
                    download="Document 1"
                    target="_"
                    href={
                      selectedUser.doc1_image
                        ? `${IMAGE_BASE_URL}${selectedUser.doc1_image}`
                        : "https://via.placeholder.com/600"
                    }
                  >
                    <IconButton aria-label="download">
                      <GetAppIcon />
                    </IconButton>
                  </a>
                }
              />
              <CardMedia
                className={classes.media}
                image={
                  selectedUser.doc1_image
                    ? `${IMAGE_BASE_URL}${selectedUser.doc1_image}`
                    : "https://via.placeholder.com/600"
                }
                title="Paella dish"
              />
            </Card>

            <Card
              className={classes.mediaCard}
              style={showDemo2 ? { display: "block" } : { display: "none" }}
            >
              <CardHeader
                avatar={
                  <Avatar aria-label="recipe" className={classes.avatar}>
                    D2
                  </Avatar>
                }
                title={
                  selectedUser.doc2_type ? selectedUser.doc2_type : "Document 1"
                }
                action={
                  <a
                    download="Document 2"
                    target="_"
                    href={
                      selectedUser.doc2_image
                        ? `${IMAGE_BASE_URL}${selectedUser.doc2_image}`
                        : "https://via.placeholder.com/600"
                    }
                  >
                    <IconButton aria-label="download">
                      <GetAppIcon />
                    </IconButton>
                  </a>
                }
              />
              <CardMedia
                className={classes.media}
                image={
                  selectedUser.doc2_image
                    ? `${IMAGE_BASE_URL}${selectedUser.doc2_image}`
                    : "https://via.placeholder.com/600"
                }
                title="Paella dish"
              />
            </Card>
          </GridItem>
        </GridContainer>
      </Dialog>
    );

  const renderUsers = () => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell>Sr. No.</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Detailed Profile</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Location</TableCell>
            {/* <TableCell>Worklog</TableCell> */}
            <TableCell align="right">Edit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user, idx) => (
            <TableRow key={idx}>
              <TableCell>{idx + 1}</TableCell>
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.username || "--"}</TableCell>
              <TableCell>{user.email || "--"}</TableCell>
              <TableCell>{user.mobile_no || "--"}</TableCell>
              <TableCell>
                {user && user?.role && user?.role?.name
                  ? user?.role?.slug == "driver"
                    ? user?.role?.name + "(" + user?.driver_type?.name + ")"
                    : user?.role?.name
                  : "--"}
              </TableCell>
              <TableCell>
                <Button
                  color="primary"
                  onClick={() => openUserDetailsInModal(user)}
                >
                  View
                </Button>
              </TableCell>
              <TableCell>
                <Switch
                  checked={user.active == 1}
                  onChange={() => {
                    handleStatusChange(user, idx);
                  }}
                  color="primary"
                  name="checkedB"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              </TableCell>
              <TableCell>
                <IconButton
                  onClick={() => {
                    openUserLocation(user);
                  }}
                  edge="end"
                  aria-label="delete"
                >
                  <LocationOnIcon
                    style={{ color: user.device[0] ? "#e93a40" : null }}
                  />
                </IconButton>
              </TableCell>
              {/* <TableCell>
                <Link to={"/admin/worklog/" + user.id}>
                  <IconButton edge="end" aria-label="delete">
                    <TimelineIcon />
                  </IconButton>
                </Link>
              </TableCell> */}
              <TableCell align="right">
                <Link to={"/admin/users/operations/" + user.id}>
                  <IconButton edge="end" aria-label="delete">
                    <CreateIcon />
                  </IconButton>
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {users.length < totalUsersCount && (
        <Grid container justify="center" style={{ padding: 20 }}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={() => loadMoreUsers()}
          >
            Load More
          </Button>
        </Grid>
      )}
    </TableContainer>
  );

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Users
            </Typography>
            <div>
              {roles.length > 0 && (
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ minWidth: 120, height: 70 }}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Roles
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={selectedRole}
                    label="District"
                    onChange={handleRoleChange}
                  >
                    {roles.map((role, idx) => (
                      <MenuItem key={idx} value={role.id}>
                        {role.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ minWidth: 120, height: 70 }}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  Active
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={selectedStatus || 1}
                  label="Active"
                  onChange={handleActiveChange}
                >
                  {STATUS_TYPES.map((status, idx) => (
                    <MenuItem key={idx} value={status.id}>
                      {status.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Link to="/admin/users/operations" style={{ marginLeft: 20 }}>
                <Button
                  // variant="outlined"
                  color="primary"
                  variant="contained"
                  className={classes.addUserButton}
                  style={{ height: "57px !important" }}
                  endIcon={<Icon>add_circle</Icon>}
                >
                  Add User
                </Button>
              </Link>
            </div>
          </Grid>
          {users.length ? (
            renderUsers()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No Users Found
            </Box>
          )}
        </GridItem>
      </GridContainer>
      {renderDialog()}
      {openLocationDialog()}
    </div>
  );
}
